var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 64,
    viewBox: "0 0 53 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7959 38.165C29.9716 37.7171 30.9601 36.8829 31.5992 35.7992L31.7583 35.5293C35.0899 29.8801 43.7476 32.2429 43.7476 38.8013V42.1937C43.7476 45.8949 40.7471 48.8954 37.0458 48.8954H30.7706C24.6116 48.8954 23.0404 40.3575 28.7959 38.165Z",
    fill: "#2D2161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1609 31.0035C19.0812 32.259 19.4307 33.5044 20.152 34.5352L20.3316 34.7918C24.092 40.1652 18.3534 47.065 12.3848 44.3467L9.29751 42.9407C5.92912 41.4066 4.4421 37.4324 5.97616 34.064L8.57704 28.3532C11.1298 22.748 19.551 24.8568 19.1609 31.0035Z",
    fill: "#2D2161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4222 27.5188C28.4456 26.7257 27.2283 26.2882 25.9703 26.278L25.657 26.2755C19.0988 26.2225 16.8061 17.546 22.4821 14.2602L25.418 12.5606C28.6212 10.7062 32.7212 11.7997 34.5755 15.003L37.7195 20.4338C40.8052 25.7642 34.2033 31.4014 29.4222 27.5188Z",
    fill: "#2D2161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorLogo);
export default __webpack_public_path__ + "static/media/colorLogo.4e03dc5d1206ae575ab518da41daf97d.svg";
export { ForwardRef as ReactComponent };